export const SEARCH_DEBOUNCE_MS = 300;

/** Meta keys never displayed on result cards. */
export const IGNORE_KEYS: readonly string[] = ['doc_created_at', 'wizard_url', 'document_type', 'highlight'];

/** Keys rendered as colored status pills instead of plain text. */
export const TAG_KEYS: readonly string[] = ['payment_status', 'policy_status'];

export type StatusPillVariant = 'green' | 'red' | 'blue' | 'yellow' | 'orange';

/**
 * Status → pill color, merged from the legacy policyStatus/paymentStatus maps
 * (commonData.js) with the payment map winning on collisions, matching the
 * legacy `{ ...policyStatus, ...paymentStatus }` merge.
 */
export const STATUS_PILL_VARIANTS: Record<string, StatusPillVariant> = {
  // policy statuses
  docs_collected: 'blue',
  docs_pending: 'red',
  coa_approval_pending: 'yellow',
  docs_rejected: 'red',
  docs_approved: 'green',
  covernote_issued: 'green',
  car_inspection_approved: 'green',
  car_inspection_rejected: 'red',
  policy_uploaded: 'green',
  policy_sent_to_user: 'green',
  policy_delivered_to_user: 'green',
  price_pending: 'yellow',
  revision_pending: 'yellow',
  price_ready: 'green',
  renewal_rejected: 'red',
  revision_required: 'red',
  policy_issued: 'green',
  cancellation_requested: 'yellow',
  cancellation_completed: 'red',
  cancellation_requested_insurer: 'yellow',
  policy_received_by_vendor: 'yellow',
  policy_sent_to_vendor: 'yellow',
  send_policy_to_user: 'yellow',
  sent_for_consideration_occupation: 'yellow',
  sent_for_consideration_declaration: 'yellow',
  insurer_rejected: 'red',
  renewal_waiting_to_issue_policy: 'yellow',
  need_to_cancel_cmi: 'yellow',
  purchased: 'green',
  // payment statuses (override policy map on collision)
  invoice_issued: 'blue',
  insurer_notified: 'orange',
  payment_verified: 'green',
  commission_transferred: 'green',
  transfer_note_issued: 'green',
  payment_proof_received: 'green',
  credit_time_exceeded: 'red',
  credit_approved: 'orange',
};

/** Design-system classes per pill variant (default when status is unmapped: orange/primary). */
export const STATUS_PILL_CLASSES: Record<StatusPillVariant, string> = {
  green: 'bg-success/10 text-success',
  red: 'bg-destructive/10 text-destructive',
  blue: 'bg-info/10 text-info',
  yellow: 'bg-warning/10 text-warning',
  orange: 'bg-primary/10 text-primary',
};
